import { motion } from "framer-motion";
import { scrollTo } from "./primitives";

const links = [
    { label: "About", hash: "#about" },
    { label: "Services", hash: "#services" },
    { label: "Projects", hash: "#projects" },
    { label: "Contact", hash: "#contact" },
];

export default function Nav() {
    return (
        <header className="fixed inset-x-0 top-0 z-50 border-b border-navy-line bg-paper/85 backdrop-blur-md">
            <div className="mx-auto flex h-16 max-w-[1400px] items-center justify-between px-5 sm:px-8">
                <button
                    data-testid="nav-logo-home"
                    onClick={() => scrollTo("#hero")}
                    className="flex items-center gap-3 text-left"
                >
                    <img
                        src="/logo.png"
                        alt="Pawan Putra Infra logo"
                        className="h-10 w-auto object-contain"
                    />
                    <span className="hidden font-display text-sm font-semibold uppercase tracking-wide2 text-navy sm:block">
                        Pawan Putra Infra
                    </span>
                </button>

                <nav className="hidden items-center gap-8 md:flex">
                    {links.map((l) => (
                        <button
                            key={l.hash}
                            data-testid={`nav-link-${l.label.toLowerCase()}`}
                            onClick={() => scrollTo(l.hash)}
                            className="link-sweep font-display text-sm font-medium uppercase tracking-[0.14em] text-ink/80 hover:text-navy"
                        >
                            {l.label}
                        </button>
                    ))}
                </nav>

                <motion.a
                    data-testid="nav-cta-call"
                    href="tel:+919468564757"
                    whileHover={{ scale: 1.03 }}
                    whileTap={{ scale: 0.97 }}
                    className="border border-navy bg-orange px-4 py-2 font-display text-sm font-semibold uppercase tracking-[0.12em] text-navy-deep transition-colors duration-300 hover:bg-navy hover:text-white"
                >
                    Call Now
                </motion.a>
            </div>
        </header>
    );
}
